import React from 'react'
import './skeletonTableRow.scss'

const SkeletonDivElement = ({
    rows,
    height = '20px',
    width = '100%',
    marginBottom = '2px',
    marginRight = '',
    borderRadius = '4px' }) => {
    return (
        <>
            {[...Array(rows)].map((_, i) =>
                <div className='skeleton-custome' style={{
                    height: height,
                    width: width,
                    marginBottom: marginBottom,
                    marginRight: marginRight,
                    borderRadius: borderRadius
                }}></div>
            )}
        </>
    );
}

export default SkeletonDivElement;